import { Grid } from '@mui/material';
import { ODSTextField as ODSTextFieldLib } from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';

import type { ODSTextFieldPropsType } from '@/types/inputTypes';

export const ODSTextField: FC<ODSTextFieldPropsType> = ({
  name,
  value = '',
  onChange,
  onKeyDown,
  onBlur,
  label,
  placeholder = '',
  disabled = false,
  helperText = '',
  InputProps = {},
  size = 'small',
  className = '',
  readOnly = false,
  maxLength,
  required,
}) => {
  const leftIconValue =
    typeof InputProps.startAdornment === 'string' ? InputProps.startAdornment : undefined;
  const rightIconValue =
    typeof InputProps.endAdornment === 'string' ? InputProps.endAdornment : undefined;
  const { startAdornment, endAdornment, readOnly: inputReadOnly, ...nativeInputProps } = InputProps;
  const isReadOnly = readOnly || (inputReadOnly ?? false);
  const mode = helperText ? 'error' : 'informative';
  return (
    <Grid
      item
      xs={12}
      sx={{ marginBottom: 2, width: '100%' }}
    >
      {startAdornment && typeof startAdornment === 'object' ? startAdornment : null}
      <ODSTextFieldLib
        inputProps={{
          type: 'text',
          ...nativeInputProps,
          id: nativeInputProps.id ?? name,
          name: name,
          required: required,
          maxLength: maxLength,
          onChange,
          onKeyDown,
          onBlur,
        }}
        placeholderText={placeholder}
        readonly={isReadOnly}
        value={value}
        labelText={label}
        disabled={disabled}
        supportMessageProps={{
          helperText: helperText,
        }}
        textFieldIconProps={{
          icon: rightIconValue,
          type: 'iconContainer',
        }}
        mode={mode}
        size={size}
        className={className}
        leftIconValue={leftIconValue}
      />
      {endAdornment && typeof endAdornment === 'object' ? endAdornment : null}
    </Grid>
  );
};
